var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDuplicateTitleIcon = function SvgDuplicateTitleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14195_29070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3368 5.66666H6.32128C5.95831 5.66666 5.66406 5.96091 5.66406 6.32388V13.3394C5.66406 13.7024 5.95831 13.9967 6.32128 13.9967H13.3368C13.6998 13.9967 13.9941 13.7024 13.9941 13.3394V6.32388C13.9941 5.96091 13.6998 5.66666 13.3368 5.66666Z",
    stroke: "#C2E550",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38 10.33H3.19C2.53278 10.33 2 9.79722 2 9.14V3.19C2 2.53278 2.53278 2 3.19 2H9.14C9.79722 2 10.33 2.53278 10.33 3.19V4.38",
    stroke: "#C2E550",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14195_29070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgDuplicateTitleIcon as ReactComponent };
export default __webpack_public_path__ + "duplicate-title-icon.svg";